import { render, staticRenderFns } from "./PigiFo.vue?vue&type=template&id=3124f25f&"
import script from "./PigiFo.vue?vue&type=script&lang=js&"
export * from "./PigiFo.vue?vue&type=script&lang=js&"
import style0 from "./PigiFo.vue?vue&type=style&index=0&id=3124f25f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports